import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageSection = () => {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: "en", label: "English - United States" },
    { code: "ru", label: "Русский" },
  ];

  const handleLanguageChange = (languageCode) => {
    localStorage.setItem('lang', languageCode);
    i18n.changeLanguage(languageCode);
    setSelectedLanguage(languageCode);
    setIsOpen(false);
    
       // Refresh the page after language change
       window.location.reload();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={dropdownRef} className="relative w-[256px]">
      {/* Dropdown Header */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="body-medium-2 text-color-2 w-full bg-black border-b border-b-[#FFFFFF52] p-2 flex justify-between items-center outline-none focus:outline-none"
      >
        <span>{languages.find((lang) => lang.code === selectedLanguage)?.label}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 text-color-2 transition-transform duration-200 ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <ul className="absolute z-10 left-0 w-full bg-[#292929] shadow-lg mt-2 body-medium-2">
          {languages.map((lang) => (
            <li
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className="flex items-center justify-between p-2 text-color-2 body-medium-2 cursor-pointer hover:bg-[#3a3a3a]"
            >
              <span>{lang.label}</span>
              {selectedLanguage === lang.code && (
                <img src="/assets/languagetick.svg" alt="Selected" className="h-4 w-4" />
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSection;
